import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["output"]
  static values = { url: String }

  update(event) {
    event.preventDefault()

    this.outputTarget.innerHTML = "Updating..."

    fetch(this.urlValue, {
      headers: { "Accept": "application/json" }
    })
    .then(response => response.json())
    .then(data => {
      this.outputTarget.innerHTML = `
        Total: ${data.counts.total}<br/>
        True: ${data.counts.true}<br/>
        False: ${data.counts.false}<br/>
        Corrections: ${data.counts.corrections}<br/>
        <a href="#" data-action="click->update-count#update" class="btn btn-sm btn-default">Update Count</a>
      `
    })
    .catch(error => {
      console.error("Error:", error)
      this.outputTarget.innerHTML = "Error updating"
    })
  }
}
